import React from 'react'
import Deck from 'components/Deck'

export default () => (
  <Deck
    slides={() => require('slides/wordpress/cool-mat-week-2')}
    title={'cool mat → Project Guide'}
  />
)



// WEBPACK FOOTER //
// ./src/pages/wordpress/cool-mat-week-2/index.js